export const AGENCY_LOADING = "AGENCY_LOADING";
export const AGENCY_RESET = "AGENCY_RESET";
export const GET_AGENCY = "GET_AGENCY";
export const GET_AGENCY_SUCCESS = "GET_AGENCY_SUCCESS";
export const GET_AGENCY_FAIL = "GET_AGENCY_FAIL";
export const DELETE_AGENCY = "DELETE_AGENCY"
export const DELETE_AGENCY_SUCCESS = "DELETE_AGENCY_SUCCESS"
export const DELETE_AGENCY_FAIL = "DELETE_AGENCY_FAIL"
export const UPDATE_AGENCY = "UPDATE_AGENCY"
export const UPDATE_AGENCY_SUCCESS = "UPDATE_AGENCY_SUCCESS"
export const UPDATE_AGENCY_FAIL = "UPDATE_AGENCY_FAIL"
export const ADD_NEW_AGENCY = "ADD_NEW_AGENCY"
export const ADD_AGENCY_SUCCESS = "ADD_AGENCY_SUCCESS"
export const ADD_AGENCY_FAIL = "ADD_AGENCY_FAIL"
export const AGENCY_RESET_CREATE = "AGENCY_RESET_CREATE"